export default __webpack_public_path__ + "static/media/kp3.69304cfd.jpg";